export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/shareholder-sagawa.43c5d9a4-d29890.png";